/**
 * @fileoverview SeedVaultRow (B163): the Plants page's one door to the Seed vault. Seed packets kept from the Plants page are
 * seeds, not plants, so no plant card ever shows them; this row, at the top of the page under the search and filter, says the
 * vault holds them and opens it. The server's Today brief sends `vault { id, held, text }`; the row draws `text` as sent (the
 * count and the words are the server's) and opens the vault bed. It is the shared DoorRow in a Card, like the bed card's rows.
 *
 * Where: PlantGrid, under PlantToolbar, in every view and above the empty garden.
 * API: none; it reads what the Today brief already holds.
 * Words: none; the server's `text`.
 *
 * @module SeedVaultRow
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '@/shared/components/ui/card';
import { DoorRow } from '@/shared/components/ui/DoorRow';
import { VaultIcon } from '@/features/seed-orders/VaultBits';
import type { BriefVault } from '@/shared/api/todayBrief';

/** What the row is given. */
export interface SeedVaultRowProps {
  /** The server's vault line from the Today brief. */
  vault: BriefVault;
}

/**
 * The Seed vault row: the vault's packet icon, the server's words, a chevron; a tap opens the vault bed.
 *
 * @param props - SeedVaultRowProps.
 */
export const SeedVaultRow: React.FC<SeedVaultRowProps> = ({ vault }) => {
  /** Opens the vault. */
  const navigate = useNavigate();
  return (
    <Card className="mb-4">
      <DoorRow icon={<VaultIcon />} onClick={() => navigate(`/beds/${vault.id}`)}>
        {vault.text}
      </DoorRow>
    </Card>
  );
};
